import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { placeCustomerOrderApi_2 } from "../CustomerCRUD";
import { toast } from "react-toastify";
import MemberHeader from "../ramnambook-registration/member-dasboard/MemberHeader";

const CheckoutList = () => {
  const cartItems = useSelector((state) => state.cart.items);
  const navigate = useNavigate();
  const pathUrl = process.env.REACT_APP_API_URL;

  const [memberDts, setMemberDts] = useState(null);
  const [loading, setLoading] = useState(false);

  /* =======================
     LOAD CUSTOMER
     ======================= */
  useEffect(() => {
    const storedCustomer = localStorage.getItem("customer");
    if (storedCustomer) {
      setMemberDts(JSON.parse(storedCustomer));
    } else {
      navigate("/");
    }
  }, [navigate]);

  const isLoggedIn = !!memberDts;

  /* =======================
     CALCULATIONS (FIXED)
     ======================= */

  const subTotal = cartItems.reduce((acc, item) => {
    if (item.isFixedQty) {
      return acc + Number(item.finalAmount || 0);
    }
    return acc + Number(item.price || 0) * Number(item.qty || 0);
  }, 0);

  const deliveryCharge = cartItems.reduce((acc, item) => {
    return acc + Number(item.courierCharges || 0);
  }, 0);
  const totalQty = cartItems.reduce((acc, item) => {
    return acc + Number(item.qty || 0);
  }, 0);

  const totalPrice = subTotal;

  const finalTotalNumber = Number(totalPrice.toFixed(2));

  /* =======================
     PLACE ORDER
     ======================= */
  const handleProceedOrder = async () => {
    if (!isLoggedIn) {
      toast.warning("Please log in to proceed");
      navigate("/", { state: { from: "/checkout" } });
      return;
    }

    if (cartItems.length === 0) {
      toast.warning("Your cart is empty");
      return;
    }

    if (!memberDts?.ramNamBookMemberID) {
      toast.error("Customer details missing. Please log in again.");
      return;
    }

    const existingOrder = localStorage.getItem("pendingOrder");
    let existingOrderID = null;

    if (existingOrder) {
      try {
        const order = JSON.parse(existingOrder);
        existingOrderID = order.orderID;
      } catch {
        localStorage.removeItem("pendingOrder");
      }
    }

    try {
      setLoading(true);

      const orderPayload = {
        customerID: memberDts.ramNamBookMemberID,
        orderTypeID: 1,
        subTotal: subTotal,
        finalTotal: finalTotalNumber,
        existingOrderID: existingOrderID,
        items: cartItems.map((item) => ({
          productCategoryID: item.prodCatgryID,
          productID: item.id,
          qty: item.qty,
          rateOnOrder: item.price,
          lineTotal: item.isFixedQty ? item.finalAmount : item.price * item.qty,
        })),
      };

      const res = await placeCustomerOrderApi_2(orderPayload);

      if (!res.data?.isSuccess) {
        throw new Error(res.data?.message || "Order creation failed");
      }

      const pendingOrder = {
        orderID: res.data.orderID,
        orderNo: res.data.orderNo,
        subTotal: subTotal,
        finalTotal: finalTotalNumber,
        isUpdated: res.data.isUpdated || false,
        timestamp: Date.now(),
      };

      localStorage.setItem("pendingOrder", JSON.stringify(pendingOrder));

      if (totalPrice > 0 && totalQty > 0) {
      toast.success(
        res.data.isUpdated
          ? "Order updated successfully. Proceed to payment."
          : "Order created successfully. Proceed to payment.",
      );
        navigate(`/payment/${res.data.orderID}`, { replace: true });
      } else {
        toast.success("Your order has been placed successfully.");
      }
    } catch (err) {
      console.error(err);
      toast.error(err.message || "Something went wrong");

      if (
        err.message?.includes("Order not found") ||
        err.message?.includes("already completed")
      ) {
        localStorage.removeItem("pendingOrder");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <MemberHeader />

      <div className="py-3 px-4">
        {/* CUSTOMER INFO */}
        {memberDts && (
          <Card className="p-3 mb-3 shadow-sm text-start position-relative">
            <button
              className="btn btn-sm btn-outline-secondary"
              style={{ position: "absolute", top: 12, right: 12 }}
              onClick={() => navigate("/member/dashboard")}
            >
              ← Back
            </button>

            {/* <p style={{ color: "#FF4F00" }} className="fs-5">
              👤 Customer Info
            </p> */}
            <p className="mb-1 text-dark d-flex align-items-center fs-2 gap-2">
              <img
                src={"/assets/logo/300-16.jpg"}
                alt="Member"
                className="cursor-pointer rounded-circle border shadow-sm"
                style={{ width: 30, height: 30, objectFit: "cover" }}
              />
              <span className="fs-6 fw-bold" style={{ color: "#FF4F00" }}>
                Customer Info
              </span>
            </p>
            <p>
              <strong>{memberDts.memberName}</strong>
            </p>
            <p>📱{memberDts.mobileNumber}</p>
            <p>{memberDts.villageCityName}</p>
            <p>
              {memberDts.addressAndText} - {memberDts.pincode}
            </p>
            <p>{memberDts.countryName}</p>
          </Card>
        )}

        <Row className="g-4">
          <Col md={cartItems.length > 0 ? 8 : 12}>
            <Card className="p-3 shadow-sm">
              <p className="fs-5">🛒 Your Cart</p>

              {cartItems.length === 0 ? (
                <>
                  <p className="text-dark text-center">Your cart is empty.</p>
                  <div className="text-center mx-2">
                    <button
                      className="btn btn-sm mt-3"
                      style={{ backgroundColor: "#FF4F00", color: "white" }}
                      onClick={() =>
                        navigate("/member/dashboard", {
                          state: { activeTab: "purchase" },
                        })
                      }
                    >
                      Add Item
                    </button>
                  </div>
                </>
              ) : (
                <>
                  {/* DESKTOP */}
                  <div className="d-none d-md-block table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Category</th>
                          <th>Name</th>
                          <th className="text-center">Qty</th>
                          {/* <th className="text-center">Price</th>
                          <th className="text-center">Courier</th> */}
                          <th className="text-end">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {cartItems.map((item) => (
                          <tr key={item.id}>
                            <td>{item.categoryName}</td>
                            <td>{item.name}</td>
                            <td className="text-center">{item.qty}</td>
                            {/* <td className="text-center">₹{item.price}</td>
                            <td className="text-center">
                              {item.courierCharges
                                ? `₹${item.courierCharges}`
                                : "Free"}
                            </td> */}
                            <td className="text-end fw-bold text-success">
                              ₹
                              {item.isFixedQty
                                ? item.finalAmount
                                : item.qty * item.price}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* MOBILE */}
                  <div className="d-block d-md-none">
                    {cartItems.map((item) => (
                      <Card key={item.id} className="mb-3">
                        <Card.Body>
                          <p className="fw-semibold">{item.name}</p>
                          <p>Qty: {item.qty}</p>
                          {/* <p>Price: ₹{item.price}</p>
                          <p>
                            Courier:{" "}
                            {item.courierCharges
                              ? `₹${item.courierCharges}`
                              : "Free"}
                          </p> */}
                          <p className="fw-bold text-success">
                            Total: ₹
                            {item.isFixedQty
                              ? item.finalAmount
                              : item.qty * item.price}
                          </p>
                        </Card.Body>
                      </Card>
                    ))}
                  </div>
                </>
              )}
            </Card>
          </Col>

          {/* ORDER SUMMARY */}
          {cartItems.length > 0 && (
            <Col md={4}>
              <Card className="p-3 shadow-sm">
                <h6 style={{ color: "#FF4F00" }}>📦 Order Summary</h6>

                {/* <div className="d-flex justify-content-between">
                  <span>Total Items</span>
                  <span>{cartItems.length}</span>
                </div> */}
                <div className="d-flex justify-content-between">
                  <span>Qty:</span>
                  <span>{totalQty}</span>
                </div>

                <div className="d-flex justify-content-between">
                  <span>Subtotal:</span>
                  <span>₹{subTotal.toFixed(2)}</span>
                </div>

                {/* <div className="d-flex justify-content-between">
                  <span>Delivery</span>
                  <span>
                    {deliveryCharge > 0 ? `₹${deliveryCharge}` : "FREE"}
                  </span>
                </div> */}

                <hr />

                <div className="d-flex justify-content-between fw-bold">
                  <span>Total Payable:</span>
                  <span style={{ color: "#FF4F00" }}>
                    ₹{totalPrice.toFixed(2)}
                  </span>
                </div>

                <Button
                  className="w-100 mt-3"
                  style={{ backgroundColor: "#FF4F00", border: "none" }}
                  onClick={handleProceedOrder}
                  disabled={loading}
                >
                  {loading ? "Processing..." : "Proceed to Payment"}
                </Button>
              </Card>
            </Col>
          )}
        </Row>
      </div>
    </>
  );
};

export default CheckoutList;
